export const HSL_ZH_TEMPLATES = {
    common: {
        comma: "，",
        period: "。",
        bullet: "• ",
        colon: "：",
        sentenceSeparator: "。"
    },
    brackets: {
        left: "（",
        right: "）"
    },
    labels: {
        lightness: "明度",
        hue: "色相",
        saturation: "饱和度",
        localColor: "局部色彩"
    },
    mappings: {
        lightnessLevel: {
            BRIGHT: "偏亮",
            DARK: "偏暗",
            NEUTRAL: "中性"
        },
        dynamicRange: {
            COMPLETE: "动态范围完整",
            PARTIAL: "动态范围较完整",
            LIMITED: "动态范围受限"
        },
        skewness: {
            DARK_BIASED: "亮度偏向暗部",
            LIGHT_BIASED: "亮度偏向亮部",
            BALANCED: "亮度分布均衡"
        },
        kurtosis: {
            CONCENTRATED: "明度集中",
            GENTLE: "明度较平缓",
            FLAT: "明度平缓"
        },
        hueTone: {
            RED: "红",
            ORANGE: "橙",
            YELLOW: "黄",
            YELLOW_GREEN: "黄绿",
            GREEN: "绿",
            CYAN: "青",
            CYAN_BLUE: "青蓝",
            BLUE: "蓝",
            BLUE_PURPLE: "蓝紫",
            PURPLE: "紫",
            MAGENTA: "洋红",
            RED_PURPLE: "红紫",
            ACHROMATIC: "无明显色相"
        },
        hueTemperature: {
            WARM: "偏暖",
            COOL: "偏冷",
            MIXED: "冷暖混合",
            NEUTRAL: "中性"
        },
        hueDistribution: {
            CONCENTRATED: "色相集中",
            SCATTERED: "色相较分散",
            VERY_SCATTERED: "色相非常分散"
        },
        hueStability: {
            stable: "色相稳定",
            shifted: "色相主轴不稳，呈多峰色调"
        },
        saturationLevel: {
            STRONG: "饱和度强",
            MODERATE: "饱和度中等",
            WEAK: "饱和度弱"
        },
        saturationDistribution: {
            CONCENTRATED: "饱和度集中",
            SCATTERED: "饱和度较分散",
            VERY_SCATTERED: "饱和度非常分散"
        },
        saturationStability: {
            stable: "饱和度稳定",
            highSaturationHighlights: "高饱和集中于高光",
            lowSaturationShadows: "低饱和集中于阴影",
            diverse: "饱和度分布多样"
        },
        saturationDeviation: {
            DEVIATION_WEAK: "饱和度波动弱",
            DEVIATION_MODERATE: "饱和度波动中等",
            DEVIATION_STRONG: "饱和度波动强"
        },
        localBalance: {
            both: "高光与低光均有明显色彩",
            highlights: "高光色彩突出",
            lowlights: "暗部色彩突出",
            neutral: "局部色彩均衡"
        },
        partitions: {
            blacks: "暗部",
            shadows: "阴影",
            midtones: "中间调",
            highlights: "高光",
            whites: "亮部"
        }
    },
    rules: {
        lightness: {
            darkComplete: "整体偏暗且动态范围完整",
            darkLimited: "整体偏暗且动态范围受限",
            darkPartial: "整体偏暗且动态范围中等",
            brightComplete: "整体偏亮且动态范围完整",
            brightLimited: "整体偏亮且动态范围受限",
            brightPartial: "整体偏亮且动态范围中等",
            neutralComplete: "整体中性且动态范围完整",
            neutralLimited: "整体中性且动态范围受限",
            neutralPartial: "整体中性且动态范围中等",
            highContrast: "高对比特征明显",
            lowKey: "低调特征明显",
            highKey: "高调特征明显",
            richShadowDetail: "暗部细节丰富",
            wellControlledHighlight: "高光细节控制良好",
            richShadow: "暗部层次丰富",
            concentratedShadow: "暗部集中",
            richHighlight: "高光层次丰富",
            brightHighlight: "高光突出",
            compressedMidtone: "中间调压缩",
            balancedMidtone: "中间调平衡"
        },
        hue: {
            OVERALL_HUE_CONSISTENCY: "色相在多个分区保持一致",
            OVERALL_HUE_VARIATIONS: "部分分区色相与整体不同",
            SHADOW_HIGHLIGHT_HUE_CONTRAST: "阴影与高光呈现冷暖对比"
        },
        saturation: {
            OVERALL_SATURATION_CONSISTENCY: "饱和度在多个分区保持一致",
            OVERALL_SATURATION_VARIATIONS: "部分分区饱和度明显不同",
            SHADOW_HIGHLIGHT_SATURATION_CONTRAST: "阴影与高光饱和度差异明显"
        }
    },
    noData: "无有效数据，跳过分析。"
};
